export default "__VITE_ASSET__ClRHDNwq__"